// extracted by mini-css-extract-plugin
export default {"row":"Sportsmens_row__faJsC","card":"Sportsmens_card__xjBak","col":"Sportsmens_col__99TKs","card_text":"Sportsmens_card_text__ub6DK","modalTitle":"Sportsmens_modalTitle__Ln8or"};